export interface DailyCheckInRequest {
  targetDate?: string;
  pulseOnly?: boolean;
  forcePulse?: boolean;
}

export interface DailyPulseDraftAnswer {
  key: string;
  prompt: string;
  value: number | boolean | string;
}

export interface DailyPulseCustomizationRequest {
  fromDailyPulse?: boolean;
  draftAnswers?: DailyPulseDraftAnswer[];
}

type DailyCheckInRequestListener = (request: DailyCheckInRequest) => void;
type DailyPulseCustomizationRequestListener = (request: DailyPulseCustomizationRequest) => void;
type DailyCheckInUpdatedListener = () => void;
type DailyPulsePreferencesListener = (enabledQuestionKeys: string[]) => void;
type DailyCheckInVisibilityListener = () => void;

const requestListeners = new Set<DailyCheckInRequestListener>();
const customizationRequestListeners = new Set<DailyPulseCustomizationRequestListener>();
const updatedListeners = new Set<DailyCheckInUpdatedListener>();
const preferencesListeners = new Set<DailyPulsePreferencesListener>();
const visibilityListeners = new Set<DailyCheckInVisibilityListener>();
let dailyCheckInOpen = false;

export const setDailyCheckInOpen = (open: boolean) => {
  if (dailyCheckInOpen === open) return;
  dailyCheckInOpen = open;
  visibilityListeners.forEach((listener) => listener());
};

export const getDailyCheckInOpen = () => dailyCheckInOpen;

export const subscribeToDailyCheckInVisibility = (listener: DailyCheckInVisibilityListener) => {
  visibilityListeners.add(listener);
  return () => {
    visibilityListeners.delete(listener);
  };
};

export const requestDailyCheckIn = (request: DailyCheckInRequest = {}) => {
  requestListeners.forEach((listener) => listener(request));
};

export const subscribeToDailyCheckInRequests = (listener: DailyCheckInRequestListener) => {
  requestListeners.add(listener);
  return () => {
    requestListeners.delete(listener);
  };
};

export const requestDailyPulseCustomization = (request: DailyPulseCustomizationRequest = {}) => {
  customizationRequestListeners.forEach((listener) => listener(request));
};

export const subscribeToDailyPulseCustomizationRequests = (
  listener: DailyPulseCustomizationRequestListener,
) => {
  customizationRequestListeners.add(listener);
  return () => {
    customizationRequestListeners.delete(listener);
  };
};

export const publishDailyCheckInUpdated = () => {
  updatedListeners.forEach((listener) => listener());
};

export const subscribeToDailyCheckInUpdates = (listener: DailyCheckInUpdatedListener) => {
  updatedListeners.add(listener);
  return () => {
    updatedListeners.delete(listener);
  };
};

export const publishDailyPulsePreferencesUpdated = (enabledQuestionKeys: string[]) => {
  preferencesListeners.forEach((listener) => listener(enabledQuestionKeys));
  publishDailyCheckInUpdated();
};

export const subscribeToDailyPulsePreferences = (listener: DailyPulsePreferencesListener) => {
  preferencesListeners.add(listener);
  return () => {
    preferencesListeners.delete(listener);
  };
};
